<template>
  <div class="footer-action">
    <button class="btn btn-outline-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" @click="cancelUpdate">
      Cancel
    </button>
    <div class="float-right">
      <v-tooltip v-if="tooltipMessage" top open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <button class="btn btn-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" v-bind="attrs" v-on="on"
            @click="saveReportTemplate">
            Update Report
          </button>
        </template>
        <span>{{ tooltipMessage }}</span>
      </v-tooltip>

      <button v-else class="btn btn-primary" :disabled="!unsavedChanges || selectedColumns.length === 0" @click="updateReport">
        Update Report
      </button>
      <button class="btn btn-outline-primary ml-2" @click="previewReport">
        Go to Preview
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {

  },

  data() {
    return {
      label: '',
      timeoutId: null,
    }
  },
  computed: {
    ...mapGetters({
      unsavedChanges: "reportTemplates/unsavedChanges",
      allReportFields: "reportTemplates/allReportFields",
      selectedColumns: "reportTemplates/selectedColumns",
    }),
    tooltipMessage() {
      if ((!this.unsavedChanges && (!this.allReportFields || this.allReportFields.length === 0)) || this.selectedColumns.length === 0) {
        return "Select at least one column name.";
      }
      if (!this.unsavedChanges && this.allReportFields.length > 0) {
        return "No changes detected in the template.";
      }
      return "";
    },
  },
  methods: {
    ...mapActions({
      saveReportTemplate: "reportTemplates/saveReportTemplate",
    }),
    updateReport() {
      this.$store.commit('reportTemplates/setConfirmShow', {
        isShow: true,
        type: 'update',
        title: 'Update Report',
        description: "Are you sure you want to update the report template?",
      });
    },
    previewReport() {
      if (!this.unsavedChanges && this.allReportFields.length > 0) {
        window.location.href = `/dashboard/report_list/${this.$route.params.id}`;
      } else {
        this.$store.commit('reportTemplates/setConfirmShow', {
          isShow: true,
          type: 'preview',
          title: 'You are about to preview this report',
          description: "You have unsaved changes. Do you want to save the report before go to report preview page?",
        });
      }
    },
    cancelUpdate() {
      this.$store.commit('reportTemplates/setConfirmShow', {
        isShow: true,
        type: 'changes',
        title: 'Unsaved Changes',
        description: "Looks like you've made some changes. Don't forget to save before you go!",
      });
    },
  },
  watch: {
    unsavedChanges(newVal) {}
  }
}
</script>

<style lang="scss" scoped>
.footer-action {
  width: 100%;
  height: 66px;
  position: absolute;
  bottom: 0;
  background-color: #FFFFFF;
  padding: 16px 16px 16px 400px;
}
</style>